module.exports = __webpack_public_path__ + "static/img/zt2-pic14.2459289.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt2-pic14.jpg
// module id = 6d9M
// module chunks = 171